import React, { useState, useEffect } from "react";
import jsPDF from "jspdf";
import { getDatabase, ref, get } from "firebase/database";
import { toast } from "react-toastify";
import Download from "../assets/images/download.png";
import KarzameLogo from "../assets/images/karzameLogo.png";

export default function DownloadReport({ userId }) {
  const [reportData, setReportData] = useState(null);

  useEffect(() => {
    const fetchReport = async () => {
      if (!userId) {
        toast.error("User ID is missing.");
        return;
      }

      const db = getDatabase();
      const reportRef = ref(db, `users/${userId}/wellbeingReport`);

      try {
        const snapshot = await get(reportRef);
        const data = snapshot.val();

        if (snapshot.exists() && data && Object.keys(data).length > 0) {
          setReportData(data);
        } else {
          // toast.error("No report data found for this user.");
          setReportData(null);
        }
      } catch (error) {
        //  console.error("Error fetching report data:", error);
        // toast.error("Failed to fetch report data.");
        setReportData(null);
      }
    };

    fetchReport();
  }, [userId]);

  const handleDownload = () => {
    const {
      reportId,
      userName,
      userPhone,
      admin,
      timestamp,
      location,
      escortStatus,
      chatTime,
      phoneTime,
      userResponse,
      responseTime,
      callMade,
      callOutcome,
      dispatchMade,
      dispatchTime,
      securityDispatched,
    } = reportData;

    const doc = new jsPDF();

    // Add Logo at the top center
    // const logo = ""; // Update with the actual path or URL to your logo
    doc.addImage(KarzameLogo, "PNG", 90, 10, 30, 30); // x, y, width, height

    // Add Report Title
    doc.setFontSize(18);
    doc.setFont("helvetica", "bold");
    doc.text("Wellbeing Check Report", 105, 50, null, null, "center");

    // Add User Image at the right corner
    // const userImage = "path_to_user_image.jpg"; // Update with actual image URL
    //doc.addImage(props?.userImage, "JPEG", 170, 10, 30, 30); // x, y, width, height

    // Section 1: Report Metadata
    doc.setFontSize(15);
    doc.setFont("helvetica", "bold");
    doc.text("Section 1: Report Metadata", 20, 70);
    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");
    doc.text(`Report ID: ${reportId}`, 20, 80);
    doc.text(`User Name: ${userName}`, 20, 90);
    doc.text(`Phone Number: ${userPhone}`, 20, 100);
    doc.text(`Admin on Duty: ${admin}`, 20, 110);
    doc.text(`Report Timestamp: ${timestamp}`, 20, 120);

    // Section 2: Escort Details
    doc.setFontSize(15);
    doc.setFont("helvetica", "bold");
    doc.text("Section 2: Escort Details", 20, 140);
    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");
    doc.text(`Location: ${location}`, 20, 150);
    doc.text(`Escort Status: ${escortStatus}`, 20, 160);

    // Section 3: Wellbeing Check Actions
    doc.setFontSize(15);
    doc.setFont("helvetica", "bold");
    doc.text("Section 3: Wellbeing Check Actions", 20, 180);
    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");
    doc.text(`Chat Message Sent At: ${chatTime}`, 20, 190);
    doc.text(`User Response Received: ${userResponse}`, 20, 200);
    doc.text(`Response Time: ${userResponse === "Yes" ? responseTime : "No Response"}`, 20, 210);
    doc.text(`Phone Call Attempt: ${phoneTime}`, 20, 220);
    doc.text(`Call Status: ${callMade}`, 20, 230);
    doc.text(`Outcome: ${callOutcome}`, 20, 240);
    doc.text(`Dispatch Initiated: ${dispatchMade}`, 20, 250);

    if (dispatchMade === "Yes" && dispatchTime) {
      doc.text(`Time Dispatched: ${dispatchTime}`, 20, 260);
    }

    doc.text(
      `Security Agent Assigned: ${securityDispatched}`,
      20,
      dispatchMade === "Yes" && dispatchTime ? 270 : 260
    );

    // Save the PDF
    doc.save("Wellbeing_Report.pdf");
  };

  return (
    <div>
      {/* {reportData && Object.keys(reportData).length > 0 ? (
        <button onClick={handleDownload} className="btn btn-danger btn-sm">
          Download
        </button>
      ) : null} */}
      {reportData && Object.keys(reportData).length > 0 ? (
        <img
          src={Download}
          alt="Download"
          onClick={handleDownload}
          style={{ cursor: "pointer", width: "24px", height: "24px" }}
        />
      ) : null}
    </div>
  );
}
